import React, { useState } from 'react';
import { auth } from '../../../../firebase';

function Profile() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const deleteMe = async () => {
    setLoading(!loading)
    // eslint-disable-next-line no-restricted-globals
    if (confirm('დარწმუნებული ხართ რომ გსურთ ჩანაწერის სამუდამოდ წაშლა?')) {
      // Save it!
      const result = await auth.currentUser.delete();
      if (result) {

      } else {
        setMessage("ვერ მოხერხდა ოპერაციის დასრულება. სცადეთ თავიდან ავტორიზაცია")
      }
    } 
  }

  const logout = () => {
    auth.signOut();
  }

  return (
    <div className="container-sm p-4">
      <p>დარწმუნებული ხარ რომ გსურს შენი ჩანაწერების ამოშლა? (ამ მოქმედებას ვერ უკუაქცევ)</p>
      <button onClick={deleteMe} className={"btn btn-danger"}>მომხმარებლის ჩანაწერების წაშლა</button>
      <div style={{ padding: 20 }} />
      <button onClick={logout} className={"btn btn-danger"}>გამოსვლა</button>
      <div style={{ padding: 20 }} />
      {message.length > 0 && <div className={"alert alert-danger"}>
        {message}
      </div>}
    </div>
  );
}

export default Profile;
